<template>
  <div class="tabs-wrap">
    <div class="tabs c-c">
      <div class="a1 flex1 tab c-c f-d-c" @click="go(0)">
        <img
          v-if="current2 !== 0"
          class="icon1"
          src="../assets/images/images/home.png"
          alt
        />
        <img
          v-if="current2 == 0"
          class="icon1"
          src="../assets/images/images/homeOff.png"
          alt
        />
        <span class="f10 name" :class="current2 == 0 ? 'purple' : ''"
          >首页</span
        >
      </div>
      <div class="a2 flex1 tab c-c f-d-c" @click="go(1)">
        <img
          v-if="current2 !== 1"
          class="icon_AI"
          src="../assets/images/images/AI_N.png"
          alt
        />
        <img
          v-if="current2 == 1"
          class="icon_AI"
          src="../assets/images/images/AI_A.png"
          alt
        />
        <span class="f10 name" :class="current2 == 1 ? 'purple' : ''"
          >推荐</span
        >
      </div>
      <div class="a3 flex1 tab c-c f-d-c plus" @click="go(2)">
        <img
          v-if="current !== 2"
          class="icon33"
          src="../assets/images/images/plus.png"
          alt
        />
        <img
          v-if="current == 2"
          class="icon33"
          src="../assets/images/images/plusOff.png"
          alt
        />
        <span
          v-if="current !== 2"
          class="f10 name span"
          :class="current == 2 ? 'purple' : ''"
          >发布</span
        >
        <span
          v-if="current == 2"
          class="f10 name span"
          :class="current == 2 ? 'purple' : ''"
          >发布</span
        >
      </div>
      <div class="a4 flex1 tab c-c f-d-c" @click="go(3)">
        <img
          v-if="current2 !== 3"
          class="icon4"
          src="../assets/images/images/mesg.png"
          alt
        />
        <img
          v-if="current2 == 3"
          class="icon4"
          src="../assets/images/images/shopA.png"
          alt
        />
        <span class="f10 name" :class="current2 == 3 ? 'purple' : ''"
          >找店</span
        >
      </div>
      <div class="a5 flex1 tab c-c f-d-c" @click="go(4)">
        <div v-if="showDot" class="red_dot"></div>
        <img
          v-if="current2 !== 4"
          class="icon5"
          src="../assets/images/images/me.png"
          alt
        />
        <img
          v-if="current2 == 4"
          class="icon5"
          src="../assets/images/images/meOff.png"
          alt
        />
        <span class="f10 name" :class="current2 == 4 ? 'purple' : ''"
          >我的</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getData } from "../Interface/http.js";
export default {
  name: "HomeTab",
  data() {
    return {
      showDot: false,
      active: 0,
      list: [
        { active: true },
        { active: false },
        { active: false },
        { active: false },
        { active: false },
      ],
      current: 0,
    };
  },
  computed: {
    current2() {
      if (this.$store.state.nowTabIndex) {
        return this.$store.state.nowTabIndex;
      } else {
        return sessionStorage.getItem("nowTabIndex") - 0;
      }
    },
  },
  methods: {
    go(index) {
      this.$store.commit("UPDATEATBINDEX", { tag: index });
      if (index == 0) {
        this.current = index;
        this.$router.push({ name: "home" });
      } else if (index == 1) {
        this.current = index;
        let token = localStorage.getItem("token");
        if(token) {
          this.$store.commit("UPDATEARTICLEDETAILALL", {
            articleDetailAll: { id: 0, title: "信息汇总" },
          });
          this.$router.push({
            path: "TabAbout",
            query: { id: 0, title: "信息汇总", active: 1 },
          });
        }else {
          this.$store.commit("UPDATEARTICLEDETAILALL", {
            articleDetailAll: { id: 0, title: "信息汇总" },
          });
          this.$router.push({
            path: "TabAbout",
            query: { id: 0, title: "信息汇总", active: 1 },
          });
          getData("/oauth/redirect/wechat").then((res) => {
            localStorage.setItem("startPage", "TabAbout");
            window.location.href = res.data.redirect_url;
          });
        }
        
      } else if (index == 2) {
        this.current = index;
        let token = localStorage.getItem("token");
        if (token) {
          setTimeout(() => {
            this.$router.push({
              path: "post",
              query: { id: 1 },
            });
            // let url="http://jfc.jfbst.com/post?id=1";
            // window.location.href(url);
            // window.location.assign="http://jfc.jfbst.com/post?time_stamp=1584090846983&id=1";
            this.current = 0;
          }, 500);
        } else {
          setTimeout(() => {
            this.$router.push({
              path: "post",
              query: { id: 1 },
            });
            // let url="http://jfc.jfbst.com/post?id=1";
            // window.location.href(url);
            // window.location.assign="http://jfc.jfbst.com/post?time_stamp=1584090846983&id=1";
            this.current = 0;
          }, 500);
          this.getToken2();
        }
      } else if (index == 3) {
        this.current = index;
        this.$router.push({
          path: "shopList",
          query: { active: 3, categoryID: 0 },
          params: { mes: { id: 1, title: "信息汇总" } },
        });
      } else if (index == 4) {
        this.current = index;
        let token = localStorage.getItem("token");
        if (token) {
          // this.$router.push({
          //       path:"updateShopInfo",
          //       query:{
          //           id:me.shopId
          //       }
          //   })
          this.$router.push({
            name: "mycenter",
            params: { mes: { id: 1, title: "信息汇总" } },
          });
        } else {
          this.$router.push({
            name: "mycenter",
            params: { mes: { id: 1, title: "信息汇总" } },
          });
          this.getToken();
        }
      }
    },
    getToken2(){
      getData("/oauth/redirect/wechat").then((res) => {
        localStorage.setItem("startPage", "postMessage");
        window.location.href = res.data.redirect_url;
      });
    },
    getToken() {
      getData("/oauth/redirect/wechat").then((res) => {
        localStorage.setItem("startPage", "myCenter");
        window.location.href = res.data.redirect_url;
      });
    },
    getUserInfo() {
      getData("/user/info", {
        token: localStorage.getItem("token")
          ? localStorage.getItem("token")
          : "jpMfzc9oh7SVC3Koac1QZz3Mh7KyngKd",
      })
        .then((res) => {
          if (res.code == 0) {
            if(res.data.unread_notify == '1' || res.data.unread_message == '1') {
              this.showDot = true;
            } else {
              this.showDot = false;
            }
          }
        })
        .catch((err) => {});
    },
  },
  activated() {
    this.getUserInfo();
  },
  mounted() {
    this.getUserInfo();
  },
};
</script>

<style scoped>
.purple {
  color: #892885;
}
.tabs-wrap {
  width: 100%;
  margin-top: 70px;
}
.red_dot {
  position: absolute;
  top: -3px;
  left: 60%;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: red;
}
.tabs {
  height: 71px;
  width: 100vw;
  background: rgb(232, 232, 232);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  /* padding: 9px 30px 11px; */
  box-sizing: border-box;
  z-index: 999;
}
.tab {
  position: relative;
}
.a1 {
  width: 109px;
}
.a2 {
  width: 145px;
}
.a3 {
  width: 175px;
}
/* .tab img {
  width: 28px;
  height: 28px;
} */
.icon1 {
  width: 25px;
  height: 23px;
}
.icon2 {
  width: 24px;
  height: 24px;
}
.icon_AI {
  width: 28px;
  height: 29px;
  margin-top: -8px;
}
.icon4 {
  width: 24px;
  height: 24px;
}
.icon5 {
  width: 24px;
  height: 24px;
}
.tab .name {
  margin: 7px 0 0 0;
}
.plus .icon3 {
  width: 25px;
  height: 25px;
}
.plus .icon33 {
  width: 53px !important;
  height: 53px !important;
  position: relative;
  top: -10px;
  /* transform: scale(1.1); */
  /* transition: all .5s; */
}
.plus .span {
  position: relative;
  top: -13px;
}
.plus .span1 {
  position: relative;
  top: -13px;
  /* transform: scale(1.1); */
  /* transition: all .5s; */
}
</style>
